export default "__VITE_ASSET__NpsgDtZI__"